import { render, staticRenderFns } from "./trinity-dialog.vue?vue&type=template&id=bbe32144&scoped=true&"
import script from "./trinity-dialog.vue?vue&type=script&lang=ts&"
export * from "./trinity-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./trinity-dialog.vue?vue&type=style&index=0&id=bbe32144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe32144",
  null
  
)

export default component.exports